export enum DerivedRole {
    SfxAdmin = 'SfxAdmin',
    Admin = 'Admin',
    User = 'User',
    Supporter = 'Supporter',
    Trainee = 'Trainee',
    SuperAdmin = 'SuperAdmin'
}
